/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import2 from '../../buttons/icon-button/icon-button.component';
import * as import3 from '../promo-card/promo-card.component.ngfactory';
import * as import4 from '../promo-card/promo-card.component';
import * as import5 from '../../orchestration/navigation.service';
import * as import6 from '../../orchestration/analytics.service';
import * as import7 from 'ng2-translate/src/translate.service';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../../menu/menu.model';
import * as import10 from '../promo.model';
import * as import11 from 'ng2-translate/src/translate.pipe';
import * as import12 from '@angular/common';
import * as import13 from '../../html-utils/element-width.directive';
import * as import14 from '../../orchestration/responsive.service';
import * as import15 from '../../orchestration/responsive.directive';
import * as import16 from '../../ui-elements/swipable.directive';
import * as import17 from '../../html-utils/css-var.directive';
import * as import18 from '../../ui-elements/touchable.directive';
import * as import19 from '../../buttons/link/link.component.ngfactory';
import * as import20 from '../../buttons/link/link.component';
import * as import21 from './promo-carousel.component';
import * as import22 from '../../identity/identity.model';
const styles_PromoCarouselComponent:any[] = ([] as any[]);
export const RenderType_PromoCarouselComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PromoCarouselComponent,
  data: {}
}
);
function View_PromoCarouselComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'carousel-edge-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.scroll(false,co.ScrollType.Click)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.LEFT;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_PromoCarouselComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.login()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_PromoCardComponent_0,import3.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import4.PromoCardComponent,[
      import5.NavigationService,
      import6.AnalyticsService,
      import0.ElementRef,
      import7.TranslateService,
      import8.SessionModel,
      import9.MenuModel,
      import10.PromoModel,
      import0.ChangeDetectorRef
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      message: [
        1,
        'message'
      ]
      ,
      image: [
        2,
        'image'
      ]
      ,
      autoCropImage: [
        3,
        'autoCropImage'
      ]
      ,
      actionLabel: [
        4,
        'actionLabel'
      ]

    }
    ,{onActivate: 'onActivate'}),
    import0.ɵpid(131072,import11.TranslatePipe,[
      import7.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    const currVal_7:any = (<any>(<any>v.parent).parent).context.ngIf.promoteMemberLoginText1;
    const currVal_8:any = (<any>(<any>v.parent).parent).context.ngIf.promoteMemberLoginText2;
    const currVal_9:any = (<any>(<any>v.parent).parent).context.ngIf.promoteMemberLoginImage;
    const currVal_10:any = (<any>(<any>v.parent).parent).context.ngIf.promoteMemberLoginImageAutoCrop;
    const currVal_11:any = import0.ɵunv(v,1,4,import0.ɵnov(v,2).transform('woa.common.login'));
    ck(v,1,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).inlineAction;
    const currVal_1:any = import0.ɵnov(v,1).cornerAction;
    const currVal_2:any = import0.ɵnov(v,1).peelAction;
    const currVal_3:any = import0.ɵnov(v,1).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,1).fadeOut;
    const currVal_5:any = import0.ɵnov(v,1).withAction;
    const currVal_6:any = import0.ɵnov(v,1).currentRestrictedOrderTypes;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_PromoCarouselComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onOrderDeal.emit((<any>v.parent).context.$implicit.entitlement)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_PromoCardComponent_0,import3.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import4.PromoCardComponent,[
      import5.NavigationService,
      import6.AnalyticsService,
      import0.ElementRef,
      import7.TranslateService,
      import8.SessionModel,
      import9.MenuModel,
      import10.PromoModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showCodeLink: [
        0,
        'showCodeLink'
      ]
      ,
      entitlement: [
        1,
        'entitlement'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_7:any = true;
    const currVal_8:any = (<any>v.parent).context.$implicit.entitlement;
    ck(v,1,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).inlineAction;
    const currVal_1:any = import0.ɵnov(v,1).cornerAction;
    const currVal_2:any = import0.ɵnov(v,1).peelAction;
    const currVal_3:any = import0.ɵnov(v,1).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,1).fadeOut;
    const currVal_5:any = import0.ɵnov(v,1).withAction;
    const currVal_6:any = import0.ɵnov(v,1).currentRestrictedOrderTypes;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_PromoCarouselComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.promoActioned((<any>v.parent).context.$implicit.promo,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_PromoCardComponent_0,import3.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import4.PromoCardComponent,[
      import5.NavigationService,
      import6.AnalyticsService,
      import0.ElementRef,
      import7.TranslateService,
      import8.SessionModel,
      import9.MenuModel,
      import10.PromoModel,
      import0.ChangeDetectorRef
    ]
      ,{promo: [
        0,
        'promo'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_7:any = (<any>v.parent).context.$implicit.promo;
    ck(v,1,0,currVal_7);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).inlineAction;
    const currVal_1:any = import0.ɵnov(v,1).cornerAction;
    const currVal_2:any = import0.ɵnov(v,1).peelAction;
    const currVal_3:any = import0.ɵnov(v,1).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,1).fadeOut;
    const currVal_5:any = import0.ɵnov(v,1).withAction;
    const currVal_6:any = import0.ɵnov(v,1).currentRestrictedOrderTypes;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_PromoCarouselComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.showAllDeals()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_PromoCardComponent_0,import3.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import4.PromoCardComponent,[
      import5.NavigationService,
      import6.AnalyticsService,
      import0.ElementRef,
      import7.TranslateService,
      import8.SessionModel,
      import9.MenuModel,
      import10.PromoModel,
      import0.ChangeDetectorRef
    ]
    ,{
      autoCropImage: [
        0,
        'autoCropImage'
      ]
      ,
      actionLabel: [
        1,
        'actionLabel'
      ]
      ,
      actionStyle: [
        2,
        'actionStyle'
      ]

    }
    ,{onActivate: 'onActivate'}),
    import0.ɵpid(131072,import11.TranslatePipe,[
      import7.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = true;
    const currVal_8:any = import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform('woa.button.deals.allDeals'));
    const currVal_9:any = co.AppDealActionStyle.INLINE;
    ck(v,1,0,currVal_7,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).inlineAction;
    const currVal_1:any = import0.ɵnov(v,1).cornerAction;
    const currVal_2:any = import0.ɵnov(v,1).peelAction;
    const currVal_3:any = import0.ɵnov(v,1).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,1).fadeOut;
    const currVal_5:any = import0.ɵnov(v,1).withAction;
    const currVal_6:any = import0.ɵnov(v,1).currentRestrictedOrderTypes;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_PromoCarouselComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'carousel-slides-slide'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(16384,(null as any),0,import12.NgSwitch,([] as any[]),{ngSwitch: [
        0,
        'ngSwitch'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_4)),
    import0.ɵdid(278528,(null as any),0,import12.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import12.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_5)),
    import0.ɵdid(278528,(null as any),0,import12.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import12.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_6)),
    import0.ɵdid(278528,(null as any),0,import12.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import12.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_7)),
    import0.ɵdid(278528,(null as any),0,import12.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import12.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.type;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.SlideType.Login;
    ck(v,4,0,currVal_1);
    const currVal_2:any = co.SlideType.Deal;
    ck(v,7,0,currVal_2);
    const currVal_3:any = co.SlideType.Promo;
    ck(v,10,0,currVal_3);
    const currVal_4:any = co.SlideType.More;
    ck(v,13,0,currVal_4);
  },(null as any));
}
function View_PromoCarouselComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'carousel-edge-button'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.scroll(true,co.ScrollType.Click)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_IconButtonComponent_0,import1.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import2.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.RIGHT;
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_PromoCarouselComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'carousel',
        1
      ]

    ]
    ,(null as any),27,'div',[
      [
        'class',
        'carousel'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]
      ,
      [
        'woa-responsive',
        ''
      ]
      ,
      [
        'woa-swipable',
        ''
      ]

    ]
      ,[[
        2,
        'ignore-swipe',
        (null as any)
      ]
    ],[
      [
        (null as any),
        'onSwipe'
      ]
      ,
      [
        (null as any),
        'dblclick'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSwipe' === en)) {
        const pd_0:any = ((<any>co.scroll(($event === co.Direction.LEFT),co.ScrollType.Swipe)) !== false);
        ad = (pd_0 && ad);
      }
      if (('dblclick' === en)) {
        const pd_1:any = ((<any>co.blockAutoScroll()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import13.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import14.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(737280,(null as any),0,import15.ResponsiveDirective,[
      import0.ElementRef,
      import14.ResponsiveService,
      import5.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(212992,(null as any),0,import16.SwipableDirective,[
      import0.ElementRef,
      import0.Renderer2
    ]
    ,{
      swipeEnabled: [
        0,
        'swipeEnabled'
      ]
      ,
      swipeDirection: [
        1,
        'swipeDirection'
      ]
      ,
      bidirectional: [
        2,
        'bidirectional'
      ]
      ,
      swipeRangeProportionOfSize: [
        3,
        'swipeRangeProportionOfSize'
      ]
      ,
      swipeMaxDistance: [
        4,
        'swipeMaxDistance'
      ]
      ,
      swipePrimeProportionOfRange: [
        5,
        'swipePrimeProportionOfRange'
      ]
      ,
      swipeDisengageDelay: [
        6,
        'swipeDisengageDelay'
      ]

    }
    ,{onSwipe: 'onSwipe'}),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'carousel-edge left'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.scroll(false,co.ScrollType.Click,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_2)),
    import0.ɵdid(16384,(null as any),0,import12.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'carousel-slides'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import12.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'scrollable',
      'scrolled-back',
      'scrolled-forth',
      'auto-scrolling',
      'swipe-scrolling',
      'click-scrolling'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import17.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--nr-visible-slides']),
      import0.ɵdid(4210688,[[
        1,
        4
      ]
    ],0,import18.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_3)),
    import0.ɵdid(802816,(null as any),0,import12.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'carousel-edge right'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.scroll(true,co.ScrollType.Click,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_8)),
    import0.ɵdid(16384,(null as any),0,import12.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    ck(v,2,0);
    const currVal_1:any = co.scrollable;
    const currVal_2:any = co.Direction.RIGHT;
    const currVal_3:any = true;
    const currVal_4:any = co.swipeRangeProportionOfSize;
    const currVal_5:any = co.swipeMaxDistance;
    const currVal_6:any = 0.25;
    const currVal_7:any = 250;
    ck(v,3,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = co.scrollable;
    ck(v,8,0,currVal_8);
    const currVal_9:any = 'carousel-slides';
    const currVal_10:any = ck(v,13,0,co.scrollable,co.scrolledBack,co.scrolledForth,(co.scrolling === co.ScrollType.Auto),(co.scrolling === co.ScrollType.Swipe),(co.scrolling === co.ScrollType.Click));
    ck(v,12,0,currVal_9,currVal_10);
    const currVal_11:any = ck(v,15,0,co.nrVisibleSlides);
    ck(v,14,0,currVal_11);
    const currVal_12:any = co.visibleSlides;
    const currVal_13:any = co.trackSlide;
    ck(v,19,0,currVal_12,currVal_13);
    const currVal_14:any = co.scrollable;
    ck(v,25,0,currVal_14);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.ignoreSwipe;
    ck(v,0,0,currVal_0);
  });
}
function View_PromoCarouselComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.showAllDeals()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import19.View_LinkComponent_0,import19.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import20.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.order.moreDeals';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_PromoCarouselComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{touchable: 0}),
    import0.ɵqud(671088640,2,{carouselER: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_PromoCarouselComponent_1)),
    import0.ɵdid(16384,(null as any),0,import12.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import12.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PromoCarouselComponent_9)),
    import0.ɵdid(16384,(null as any),0,import12.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import21.PromoCarouselComponent = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.SessionEvents.currentApp$));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.morePromotionalCards && !co.showMorePromotionalCardsAsSlide);
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_PromoCarouselComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-carousel',([] as any[]),(null as any),(null as any),(null as any),View_PromoCarouselComponent_0,RenderType_PromoCarouselComponent)),
    import0.ɵdid(770048,(null as any),0,import21.PromoCarouselComponent,[
      import8.SessionModel,
      import22.IdentityModel,
      import6.AnalyticsService,
      import5.NavigationService,
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PromoCarouselComponentNgFactory:import0.ComponentFactory<import21.PromoCarouselComponent> = import0.ɵccf('woa-promo-carousel',import21.PromoCarouselComponent,View_PromoCarouselComponent_Host_0,{
  promoteMemberLogin: 'promoteMemberLogin',
  deals: 'deals',
  promos: 'promos',
  morePromotionalCards: 'morePromotionalCards',
  showMorePromotionalCardsAsSlide: 'showMorePromotionalCardsAsSlide',
  nrVisibleSlides: 'nrVisibleSlides',
  autoScrollEnabled: 'autoScrollEnabled'
}
,{
  onOrderDeal: 'onOrderDeal',
  onPromoActioned: 'onPromoActioned'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcHJvbW8vcHJvbW8tY2Fyb3VzZWwvcHJvbW8tY2Fyb3VzZWwuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcHJvbW8vcHJvbW8tY2Fyb3VzZWwvcHJvbW8tY2Fyb3VzZWwuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9wcm9tby9wcm9tby1jYXJvdXNlbC9wcm9tby1jYXJvdXNlbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcHJvbW8vcHJvbW8tY2Fyb3VzZWwvcHJvbW8tY2Fyb3VzZWwuY29tcG9uZW50LnRzLlByb21vQ2Fyb3VzZWxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2ICpuZ0lmPVwiKFNlc3Npb25FdmVudHMuY3VycmVudEFwcCQgfCBhc3luYykgYXMgYXBwRGF0YVwiXG4gICAgIGNsYXNzPVwiY2Fyb3VzZWxcIiAjY2Fyb3VzZWwgd29hLXJlc3BvbnNpdmUgd29hLWVsZW1lbnQtd2lkdGhcbiAgICAgd29hLXN3aXBhYmxlIFtzd2lwZUVuYWJsZWRdPVwic2Nyb2xsYWJsZVwiIFtzd2lwZURpcmVjdGlvbl09XCJEaXJlY3Rpb24uUklHSFRcIiBbYmlkaXJlY3Rpb25hbF09XCJ0cnVlXCJcbiAgICAgW3N3aXBlTWF4RGlzdGFuY2VdPVwic3dpcGVNYXhEaXN0YW5jZVwiIFtzd2lwZVJhbmdlUHJvcG9ydGlvbk9mU2l6ZV09XCJzd2lwZVJhbmdlUHJvcG9ydGlvbk9mU2l6ZVwiXG4gICAgIFtzd2lwZVByaW1lUHJvcG9ydGlvbk9mUmFuZ2VdPVwiMC4yNVwiIFtzd2lwZURpc2VuZ2FnZURlbGF5XT1cIjI1MFwiIFtjbGFzcy5pZ25vcmUtc3dpcGVdPVwiaWdub3JlU3dpcGVcIlxuICAgICAob25Td2lwZSk9XCJzY3JvbGwoJGV2ZW50ID09PSBEaXJlY3Rpb24uTEVGVCwgU2Nyb2xsVHlwZS5Td2lwZSlcIlxuICAgICAoZGJsY2xpY2spPVwiYmxvY2tBdXRvU2Nyb2xsKClcIj5cbiAgICA8ZGl2IGNsYXNzPVwiY2Fyb3VzZWwtZWRnZSBsZWZ0XCIgKGNsaWNrKT1cInNjcm9sbChmYWxzZSwgU2Nyb2xsVHlwZS5DbGljaywgJGV2ZW50KVwiPlxuICAgICAgICA8d29hLWljb24tYnV0dG9uICpuZ0lmPVwic2Nyb2xsYWJsZVwiIGNsYXNzPVwiY2Fyb3VzZWwtZWRnZS1idXR0b25cIiBbdHlwZV09XCJJY29uQnV0dG9uVHlwZS5MRUZUXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAob25BY3RpdmF0ZSk9XCJzY3JvbGwoZmFsc2UsIFNjcm9sbFR5cGUuQ2xpY2spXCI+PC93b2EtaWNvbi1idXR0b24+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cImNhcm91c2VsLXNsaWRlc1wiIHdvYS10b3VjaGFibGVcbiAgICAgICAgIFtuZ0NsYXNzXT1cIntcbiAgICAgICAgICAgICAnc2Nyb2xsYWJsZSc6IHNjcm9sbGFibGUsXG4gICAgICAgICAgICAgJ3Njcm9sbGVkLWJhY2snOiBzY3JvbGxlZEJhY2ssXG4gICAgICAgICAgICAgJ3Njcm9sbGVkLWZvcnRoJzogc2Nyb2xsZWRGb3J0aCxcbiAgICAgICAgICAgICAnYXV0by1zY3JvbGxpbmcnOiBzY3JvbGxpbmcgPT09IFNjcm9sbFR5cGUuQXV0byxcbiAgICAgICAgICAgICAnc3dpcGUtc2Nyb2xsaW5nJzogc2Nyb2xsaW5nID09PSBTY3JvbGxUeXBlLlN3aXBlLFxuICAgICAgICAgICAgICdjbGljay1zY3JvbGxpbmcnOiBzY3JvbGxpbmcgPT09IFNjcm9sbFR5cGUuQ2xpY2tcbiAgICAgICAgIH1cIlxuICAgICAgICAgW3dvYS1jc3MtdmFyXT1cIntcbiAgICAgICAgICAgICAnLS1uci12aXNpYmxlLXNsaWRlcyc6IG5yVmlzaWJsZVNsaWRlc1xuICAgICAgICAgfVwiPlxuICAgICAgICA8ZGl2ICpuZ0Zvcj1cImxldCBzbGlkZSBvZiB2aXNpYmxlU2xpZGVzOyB0cmFja0J5OiB0cmFja1NsaWRlXCIgW25nU3dpdGNoXT1cInNsaWRlLnR5cGVcIlxuICAgICAgICAgICAgIGNsYXNzPVwiY2Fyb3VzZWwtc2xpZGVzLXNsaWRlXCI+XG4gICAgICAgICAgICA8d29hLXByb21vLWNhcmQgKm5nU3dpdGNoQ2FzZT1cIlNsaWRlVHlwZS5Mb2dpblwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgW3RpdGxlXT1cImFwcERhdGEucHJvbW90ZU1lbWJlckxvZ2luVGV4dDFcIiBbbWVzc2FnZV09XCJhcHBEYXRhLnByb21vdGVNZW1iZXJMb2dpblRleHQyXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBbaW1hZ2VdPVwiYXBwRGF0YS5wcm9tb3RlTWVtYmVyTG9naW5JbWFnZVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgW2F1dG9Dcm9wSW1hZ2VdPVwiYXBwRGF0YS5wcm9tb3RlTWVtYmVyTG9naW5JbWFnZUF1dG9Dcm9wXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBbYWN0aW9uTGFiZWxdPVwiJ3dvYS5jb21tb24ubG9naW4nIHwgdHJhbnNsYXRlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAob25BY3RpdmF0ZSk9XCJsb2dpbigpXCI+PC93b2EtcHJvbW8tY2FyZD5cbiAgICAgICAgICAgIDx3b2EtcHJvbW8tY2FyZCAqbmdTd2l0Y2hDYXNlPVwiU2xpZGVUeXBlLkRlYWxcIiBbZW50aXRsZW1lbnRdPVwic2xpZGUuZW50aXRsZW1lbnRcIiBbc2hvd0NvZGVMaW5rXT1cInRydWVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlKT1cIm9uT3JkZXJEZWFsLmVtaXQoc2xpZGUuZW50aXRsZW1lbnQpXCI+PC93b2EtcHJvbW8tY2FyZD5cbiAgICAgICAgICAgIDx3b2EtcHJvbW8tY2FyZCAqbmdTd2l0Y2hDYXNlPVwiU2xpZGVUeXBlLlByb21vXCIgW3Byb21vXT1cInNsaWRlLnByb21vXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAob25BY3RpdmF0ZSk9XCJwcm9tb0FjdGlvbmVkKHNsaWRlLnByb21vLCAkZXZlbnQpXCI+PC93b2EtcHJvbW8tY2FyZD5cbiAgICAgICAgICAgIDx3b2EtcHJvbW8tY2FyZCAqbmdTd2l0Y2hDYXNlPVwiU2xpZGVUeXBlLk1vcmVcIiBbYWN0aW9uTGFiZWxdPVwiJ3dvYS5idXR0b24uZGVhbHMuYWxsRGVhbHMnIHwgdHJhbnNsYXRlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBbYXV0b0Nyb3BJbWFnZV09XCJ0cnVlXCIgW2FjdGlvblN0eWxlXT1cIkFwcERlYWxBY3Rpb25TdHlsZS5JTkxJTkVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlKT1cInNob3dBbGxEZWFscygpXCI+PC93b2EtcHJvbW8tY2FyZD5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cImNhcm91c2VsLWVkZ2UgcmlnaHRcIiAoY2xpY2spPVwic2Nyb2xsKHRydWUsIFNjcm9sbFR5cGUuQ2xpY2ssICRldmVudClcIj5cbiAgICAgICAgPHdvYS1pY29uLWJ1dHRvbiAqbmdJZj1cInNjcm9sbGFibGVcIiBjbGFzcz1cImNhcm91c2VsLWVkZ2UtYnV0dG9uXCIgW3R5cGVdPVwiSWNvbkJ1dHRvblR5cGUuUklHSFRcIlxuICAgICAgICAgICAgICAgICAgICAgICAgIChvbkFjdGl2YXRlKT1cInNjcm9sbCh0cnVlLCBTY3JvbGxUeXBlLkNsaWNrKVwiPjwvd29hLWljb24tYnV0dG9uPlxuICAgIDwvZGl2PlxuPC9kaXY+XG48d29hLWxpbmsgKm5nSWY9XCJtb3JlUHJvbW90aW9uYWxDYXJkcyAmJiAhc2hvd01vcmVQcm9tb3Rpb25hbENhcmRzQXNTbGlkZVwiXG4gICAgICAgICAgW2xpbmtdPVwiJ3dvYS5idXR0b24ub3JkZXIubW9yZURlYWxzJ1wiIChvbkFjdGl2YXRlKT1cInNob3dBbGxEZWFscygpXCI+PC93b2EtbGluaz5cbiIsIjx3b2EtcHJvbW8tY2Fyb3VzZWw+PC93b2EtcHJvbW8tY2Fyb3VzZWw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ1FRO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQ2lCO1FBQUE7UUFBQTtNQUFBO01BRGpCO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUFpRTtJQUFqRSxTQUFpRSxTQUFqRTs7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLDZCQUFBOzs7OztJQWlCSTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUtnQjtRQUFBO1FBQUE7TUFBQTtNQUxoQjtJQUFBO2dCQUFBOzs7Ozs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFJZ0I7OztJQUFBO0lBQUE7OztJQUhBO0lBQTBDO0lBQzFDO0lBQ0E7SUFDQTtJQUpoQixTQUNnQixVQUEwQyxVQUMxQyxVQUNBLFdBQ0EsVUFKaEI7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLHFFQUFBOzs7OztJQU1BO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQ2dCO1FBQUE7UUFBQTtNQUFBO01BRGhCO0lBQUE7Z0JBQUE7Ozs7Ozs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBOzs7SUFBaUY7SUFBbEM7SUFBL0MsU0FBaUYsVUFBbEMsU0FBL0M7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLHFFQUFBOzs7OztJQUVBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQ2dCO1FBQUE7UUFBQTtNQUFBO01BRGhCO0lBQUE7Z0JBQUE7Ozs7Ozs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7O0lBQWdEO0lBQWhELFNBQWdELFNBQWhEOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxxRUFBQTs7Ozs7SUFFQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUVnQjtRQUFBO1FBQUE7TUFBQTtNQUZoQjtJQUFBO2dCQUFBOzs7Ozs7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBK0M7OztJQUFBO0lBQUE7Ozs7SUFDL0I7SUFEK0I7SUFDUjtJQUR2QyxTQUNnQixVQUQrQixVQUNSLFNBRHZDOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxxRUFBQTs7Ozs7TUFaSjtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDbUM7SUFDL0I7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFLd0Q7SUFDeEQ7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDb0Y7SUFDcEY7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDbUY7SUFDbkY7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFFK0Q7Ozs7SUFkTDtJQUE5RCxTQUE4RCxTQUE5RDtJQUVvQjtJQUFoQixTQUFnQixTQUFoQjtJQU1nQjtJQUFoQixTQUFnQixTQUFoQjtJQUVnQjtJQUFoQixVQUFnQixTQUFoQjtJQUVnQjtJQUFoQixVQUFnQixTQUFoQjs7Ozs7TUFNSjtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUNpQjtRQUFBO1FBQUE7TUFBQTtNQURqQjtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Ozs7SUFBaUU7SUFBakUsU0FBaUUsU0FBakU7O0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSw2QkFBQTs7Ozs7SUF6Q1I7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUtLO1FBQUE7UUFBQTtNQUFBO01BQ0E7UUFBQTtRQUFBO01BQUE7TUFOTDtJQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTtnQkFBQTs7Ozs7O0lBQUE7S0FBQTtnQkFBQTs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFNb0M7TUFDaEM7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFnQztRQUFBO1FBQUE7TUFBQTtNQUFoQztJQUFBO0lBQWtGO0lBQzlFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDa0Y7SUFDaEY7SUFDTjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQ0s7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO2tCQURMO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBU0s7a0JBVEw7UUFBQTtRQUFBO01BQUE7SUFBQTtJQVdRO0lBQ0o7Z0JBQUE7Ozs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQWVNO0lBQ0o7TUFDTjtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQWlDO1FBQUE7UUFBQTtNQUFBO01BQWpDO0lBQUE7SUFBa0Y7SUFDOUU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUNpRjtJQUMvRTs7OztJQTNDVjtJQUFBO0lBRWtCO0lBQTRCO0lBQW1DO0lBQ3RDO0lBQXRDO0lBQ0E7SUFBcUM7SUFKMUMsU0FFa0IsVUFBNEIsVUFBbUMsVUFDdEMsVUFBdEMsVUFDQSxVQUFxQyxTQUoxQztJQVF5QjtJQUFqQixTQUFpQixTQUFqQjtJQUdDO0lBQ0E7SUFETCxVQUFLLFVBQ0EsVUFETDtJQVNLO0lBVEwsVUFTSyxVQVRMO0lBWVM7SUFBQTtJQUFMLFVBQUsscUJBQUw7SUFrQmlCO0lBQWpCLFVBQWlCLFVBQWpCOzs7SUFyQzhEO0lBSnRFLFNBSXNFLFNBSnRFOzs7OztNQTZDQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUNnRDtRQUFBO1FBQUE7TUFBQTtNQURoRDtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7OztJQUNVO0lBRFYsU0FDVSxTQURWOzs7Ozs7O0lBN0NBO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUs7SUE0Q0M7SUFDTjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQ3lGOzs7O0lBOUNwRjtJQUFMLFNBQUssU0FBTDtJQTZDVTtJQUFWLFNBQVUsU0FBVjs7Ozs7SUM3Q0E7Z0JBQUE7Ozs7Ozs7SUFBQTtLQUFBOzs7SUFBQTs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/promo/promo-carousel/promo-carousel.component.ngfactory.ts